import { Spin } from 'antd'
import { FC } from 'react'

interface LoadingSpinnerProps {
	/** Size of the spinner */
	size?: 'small' | 'default' | 'large'
	/** Custom className for the container */
	className?: string
	/** Whether to use full screen height */
	fullScreen?: boolean
}

/**
 * Shared loading spinner component for consistent loading states
 *
 */
const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'large', className = '', fullScreen = true }) => {
	const containerClasses = fullScreen ? `flex justify-center items-center h-screen ${className}`.trim() : `flex justify-center items-center ${className}`.trim()

	return (
		<div className={containerClasses}>
			<Spin size={size} />
		</div>
	)
}

export default LoadingSpinner
